"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateAddHabitatWizard = exports.validateAddHabitat = void 0;
var isEmpty = function (value) {
    return value === undefined || value === null || value === '';
};
/**
 * Backend
 * @param body
 */
var validateAddHabitat = function (body) {
    var errors = {};
    var nameError = validateHabitatName(body.name);
    if (nameError) {
        errors.habitatName = nameError;
    }
    return errors;
};
exports.validateAddHabitat = validateAddHabitat;
var habitatNameRegExp = /^[\w\s\d[\]äöüßÄÖÜ()-]+$/;
var validateHabitatName = function (habitatName) {
    if (!habitatName || isEmpty(habitatName)) {
        return { id: 'newHabitat.stepOne.error.missing_habitat_name' };
    }
    else if (habitatName.length < 3 || habitatName.length > 65) {
        return { id: 'newHabitat.stepOne.error.habitat_name_length' };
    }
    else if (!habitatNameRegExp.test(habitatName)) {
        return {
            id: 'newHabitat.stepOne.error.it_can_contain_only_alphanumeric_symbols_and_spaces',
        };
    }
};
/**
 * Frontend
 * @param values
 */
function validateAddHabitatWizard(values) {
    var errors = {};
    errors.habitatName = validateHabitatName(values.habitatName);
    return errors;
}
exports.validateAddHabitatWizard = validateAddHabitatWizard;
//# sourceMappingURL=habitat.js.map